if (!customElements.get("carbon-counter")) {
  class CarbonCounter extends HTMLElement {
    static dailySequestrationKg = 7997.86;
    static secondsPerDay = 24 * 60 * 60;
    static intervalTime = 1000;

    constructor() {
      super();

      this.startDate = new Date(this.getAttribute("start-date") || '2024-01-01');
      this.lastTick = performance.now();
      
      this.updateCount = this.updateCount.bind(this);
      
      requestAnimationFrame(this.updateCount);

      window.addEventListener("focus", () => requestAnimationFrame(this.updateCount))
    }

    get sequestrationPerSecond() {
      return this.constructor.dailySequestrationKg / this.constructor.secondsPerDay;
    }

    updateCount() {
      const delta = (performance.now() - this.lastTick) / this.constructor.intervalTime;

      if (delta > 1) {
        const currentDate = new Date();
        const timeDifference = currentDate - this.startDate;
        const secondsSinceStartDate = Math.floor(timeDifference / 1000);
        const totalSequestration = this.sequestrationPerSecond * secondsSinceStartDate;
        const displaySequestration = totalSequestration.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        this.textContent = `${displaySequestration}kg`;

        this.lastTick = performance.now();
      }
			
      requestAnimationFrame(this.updateCount);
    }
  }

  customElements.define("carbon-counter", CarbonCounter);
}